export const WHATSAPP_LINK = 'https://wa.me/573113238346';
export const CONTACT_PHONE = '311 323 8346';
export const COMPANY_LEGAL = 'DESPIC S.A.S.';
export const PAY_DOMAIN = 'https://pay.somoskobra.com';

export const NAV_LINKS = [
  {href: '#producto', label: 'Producto'},
  {href: '#como-funciona', label: 'Cómo funciona'},
  {href: '#casos', label: 'Casos de uso'},
  {href: '#developers', label: 'Developers'},
] as const;

/** Datos demostrativos para visuales de la landing — no representan transacciones reales. */
export const DEMO_TRANSACTION = {
  title: 'Operación',
  status: 'Pago confirmado',
  amount: '$1.250.000',
  currency: 'COP',
  reference: 'ORD-1029',
  method: 'Transferencia',
  state: 'Aprobado',
  origin: 'API',
  webhook: 'Entregado',
  nextAction: 'Dispersión programada',
  time: 'Hoy, 4:00 p. m.',
} as const;

export const DEMO_TIMELINE = [
  'Cobro creado',
  'Pago recibido',
  'Confirmación recibida',
  'Webhook entregado',
  'Dispersión programada',
] as const;
